import React, { useState } from "react";
import {
  CheckCircleOutline,
  RocketLaunch,
  WorkspacePremium,
} from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import SubscriptionModal from "../subscription-modal";
import "./styles.scss";

const TRIAL_BENEFITS = [
  "AI-Powered similarity search with 5 searches",
  "Florence agent with 3 searches",
  "No credit card required",
];

const PRO_BENEFITS = [
  "Unlimited AI-Powered similarity search",
  "Full Florence agent with fair usage policy",
  "Priority support & billing portal",
];

function SubscribePlanCard({ freeTrial = false }) {
  const history = useHistory();
  const [subscriptionPreview, setSubscriptionPreview] = useState(false);

  return (
    <div className="subscribe-plan">
      <header className="subscribe-plan__header">
        <p className="subscribe-plan__eyebrow">Professional plan</p>
        <h2 className="subscribe-plan__title">
          {freeTrial ? "Upgrade when you're ready" : "Choose how you want to start"}
        </h2>
        <p className="subscribe-plan__subtitle">
          {freeTrial
            ? "Your free trial is active. Keep exploring, or subscribe for unlimited access."
            : "Try Conceptor free, or subscribe now for full Professional access."}
        </p>
      </header>

      <div className="subscribe-plan__options">
        <article
          className={`subscribe-plan__option ${
            freeTrial ? "subscribe-plan__option--active" : ""
          }`}
        >
          {freeTrial && (
            <span className="subscribe-plan__badge">Current plan</span>
          )}
          <div className="subscribe-plan__option-icon subscribe-plan__option-icon--trial">
            <RocketLaunch />
          </div>
          <h3 className="subscribe-plan__option-title">Free trial</h3>
          <p className="subscribe-plan__option-price">
            $0 <span>to start</span>
          </p>
          <p className="subscribe-plan__option-desc">
            Explore core features with limited trial usage.
          </p>
          <ul className="subscribe-plan__benefits">
            {TRIAL_BENEFITS.map((item) => (
              <li key={item}>
                <CheckCircleOutline />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <button
            type="button"
            className="subscribe-plan__btn subscribe-plan__btn--ghost"
            onClick={() => history.push("/dataset")}
          >
            {freeTrial ? "Continue free trial" : "Start free trial"}
          </button>
        </article>

        <article className="subscribe-plan__option subscribe-plan__option--featured">
          <span className="subscribe-plan__badge subscribe-plan__badge--featured">
            Recommended
          </span>
          <div className="subscribe-plan__option-icon subscribe-plan__option-icon--pro">
            <WorkspacePremium />
          </div>
          <h3 className="subscribe-plan__option-title">Subscribe</h3>
          <p className="subscribe-plan__option-price">
            $50 <span>/ month</span>
          </p>
          <p className="subscribe-plan__option-desc">
            Full access to datasets, exports, and Florence.
          </p>
          <ul className="subscribe-plan__benefits">
            {PRO_BENEFITS.map((item) => (
              <li key={item}>
                <CheckCircleOutline />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <button
            type="button"
            className="subscribe-plan__btn subscribe-plan__btn--primary"
            onClick={() => setSubscriptionPreview(true)}
          >
            Subscribe now
          </button>
          <p className="subscribe-plan__footnote">Or $540 / year · cancel anytime</p>
        </article>
      </div>

      <SubscriptionModal
        preview={subscriptionPreview}
        closeHandler={() => setSubscriptionPreview(false)}
      />
    </div>
  );
}

export default SubscribePlanCard;
